// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__uTM6s","twoMain":"SecTwo_twoMain__+VQoH","service":"SecTwo_service__iPafD","btn":"SecTwo_btn__hhhg1"};